const TO_STRING = ( value ) => {
  if ( typeof value !== 'boolean' && ! value ) return null

  return `${ value }`
}

export default TO_STRING
